import {
    CREATE_GENERAL_PURCHASE_BILL,
    DELETE_GENERAL_PURCHASE_BILL,
    GET_GENERAL_PURCHASE_BILLS,
    GET_GENERAL_PURCHASE_BILLS_PAGE,
    GENERAL_PURCHASE_BILL_REQUEST,
    GENERAL_PURCHASE_BILL_REQUEST_SUCCESS,
    GENERAL_PURCHASE_BILL_REQUEST_FAILURE,
    UPDATE_GENERAL_PURCHASE_BILL
  } from "../types/general-purchase-bill-types";
  
  const initialState = {
    generalPurchaseBills: [],
    generalPurchaseBillsPage: [],
    page: 1,
    pageSize: 10,
    search: '',
    where: {},
    total: 0,
    loading: false,
    error: null,
  };
  
  const generalPurchaseBillReducer = (state = initialState, action) => {
    switch (action.type) {
      case GENERAL_PURCHASE_BILL_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_GENERAL_PURCHASE_BILLS: {
        return {
          ...state,
          generalPurchaseBills: [...action.payload],
          loading: false,
          error: null
        }
      }
      case GET_GENERAL_PURCHASE_BILLS_PAGE: {
        const { data, total, page, pageSize, search, where } = action.payload || {};
        return {
          ...state,
          generalPurchaseBillsPage: [...data],
          total,
          page,
          pageSize,
          search: search || '',
          where: where || {},
          loading: false,
          error: null
        }
      }
      case CREATE_GENERAL_PURCHASE_BILL:
        return {
          ...state,
          generalPurchaseBills: [action.payload, ...state.generalPurchaseBills],
          loading: false,
          error: null
        };
      case UPDATE_GENERAL_PURCHASE_BILL:
        const generalPurchaseBillsData = state.generalPurchaseBills.slice(0);
        const uIndex = generalPurchaseBillsData.findIndex((data) => data.id === action.payload.id);
        generalPurchaseBillsData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          generalPurchaseBills: [ ...generalPurchaseBillsData ],
          loading: false,
          error: null
        };
      case DELETE_GENERAL_PURCHASE_BILL:
        const generalPurchaseBills = state.generalPurchaseBills?.slice(0);
        const index = generalPurchaseBills.findIndex((data) => data.id === action.id);
        if (index > -1) {
          generalPurchaseBills.splice(index, 1);
        }
        return {
          ...state,
          generalPurchaseBills: [...generalPurchaseBills],
          loading: false,
          error: null
        }
      case GENERAL_PURCHASE_BILL_REQUEST_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: null
        }
      }
      case GENERAL_PURCHASE_BILL_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };
  
  export default generalPurchaseBillReducer;
  